module.exports = __webpack_public_path__ + "static/media/maintenance.50b34ac5.png";